'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { CrossBVModal } from 'assets/icons/CrossBVModal';
import ComparePlans from './buy/india/ComparePlans';
import type { CompareCategory, ComparePlansOrigin } from './buy/india/types';
import styles from './PlansCompareModal.module.css';

interface PlansCompareModalProps {
  headers: readonly string[];
  categories: readonly CompareCategory[];
  onClose: () => void;
  compareOrigin?: ComparePlansOrigin;
  /** Actions pinned under the table, e.g. the gift page's per-plan CTAs. */
  footer?: React.ReactNode;
}

export const PlansCompareModal: React.FC<PlansCompareModalProps> = ({
  headers,
  categories,
  onClose,
  compareOrigin,
  footer,
}) => {
  const t = useTranslations('diagnostics');
  const tLab = useTranslations('performance-lab');

  return (
    <div
      className={styles.modalContainer}
      role="dialog"
      aria-modal="true"
      aria-label={tLab('plansSection.compareModalAria')}
    >
      <div className={styles.modalHeader}>
        <h2 className={styles.modalTitle}>{t('ui.comparePlans')}</h2>
        <button
          className={styles.closeButton}
          type="button"
          onClick={onClose}
          aria-label={tLab('plansSection.compareModalClose')}
        >
          <CrossBVModal />
        </button>
      </div>
      {/* Focusable so the table can be scrolled with the keyboard. */}
      <div
        className={styles.modalScrollArea}
        data-lenis-prevent="true"
        tabIndex={0}
        role="region"
        aria-label={t('ui.comparePlans')}
      >
        <ComparePlans
          headers={[...headers]}
          categories={[...categories]}
          stickyTopOffset={0}
          forceExpanded
          compareOrigin={compareOrigin}
        />
      </div>
      {footer ? <div className={styles.modalFooter}>{footer}</div> : null}
    </div>
  );
};
